import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { reduxForm, getFormValues, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { createAnnouncement, updateAnnouncement } from 'ducks/system'
import r from 'reactotron-react-js'

const AnnouncementModal = (props) => {
  const { valueForm, setShowModal } = props

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='lg' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Announcement</DialogTitle>
      <DialogContent>
        <form>
          <Field name='message' label='Message' type={type.textArea} component={FieldInput} />
          <div style={{ display: 'flex' }}>
            <Field name='startTime' label='Start Time' type={type.dateTime} component={FieldInput} />
            <Field name='endTime' label='End Time' type={type.dateTime} component={FieldInput} />
          </div>
          <Field name='buyer' label='Show on DTGO' type={type.checkbox} component={FieldInput} />
          <Field name='seller' label='Show on Vendor' type={type.checkbox} component={FieldInput} />
        </form>
      </DialogContent>
      <DialogActions>
        {
          valueForm.id ? 
            <Button
              type='button'
              content='Save'
              color='blue'
              icon='save'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => props.updateAnnouncement(valueForm, () => setShowModal(false)) }
            /> : 
            <Button
              type='button'
              content='Create'
              color='blue'
              icon='paper plane outline'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => props.createAnnouncement(valueForm, () => setShowModal(false))}
            />
        }
        <Button
          type='button'
          content='Cancel'
          color='red'
          icon='times'
          labelPosition='right'
          style={{ marginRight: '5px' }}
          onClick={() => setShowModal(false)}
        />
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const { data } = props
  const editData = data || {}
  const valueForm = getFormValues('announcementForm')(state) || {}
  
  return ({
    initialValues: {
      id: editData.id,
      message: editData.message,
      startTime: editData.startTime,
      endTime: editData.endTime,
      buyer: editData.buyer,
      seller: editData.seller
    },
    valueForm: valueForm
  })
}

const mapDispatchToProps = {
  createAnnouncement,
  updateAnnouncement
}

const AnnouncementModalForm = reduxForm({
  form: 'announcementForm',
  enableReinitialize: true,
})(AnnouncementModal)

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementModalForm)